if (!customElements.get('product-card-media')) {
  customElements.define(
    'product-card-media',
    class ProductCardMedia extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('.pcard-media__track');
        this.thumb = this.querySelector('.pcard-media__scrollbar-thumb');
        this.prevButton = this.querySelector('.pcard-media__arrow--prev');
        this.nextButton = this.querySelector('.pcard-media__arrow--next');
        this.rafId = null;
      }

      connectedCallback() {
        if (!this.track || this.slideCount <= 1) return;

        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.prevButton?.addEventListener('click', (event) => this.move(event, -1));
        this.nextButton?.addEventListener('click', (event) => this.move(event, 1));

        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
      }

      get slideCount() {
        return this.track ? this.track.children.length : 0;
      }

      get currentIndex() {
        if (!this.track || this.track.clientWidth === 0) return 0;
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      move(event, direction) {
        // Stop the surrounding product link from firing on arrow click.
        event.preventDefault();
        event.stopPropagation();

        const target = Math.min(Math.max(this.currentIndex + direction, 0), this.slideCount - 1);
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
      }

      onScroll() {
        if (this.rafId) return;
        this.rafId = requestAnimationFrame(() => {
          this.update();
          this.rafId = null;
        });
      }

      update() {
        const index = this.currentIndex;

        // Size and position the custom scroll thumb to mirror the native scroll.
        if (this.thumb && this.track) {
          const { scrollWidth, clientWidth, scrollLeft } = this.track;
          const ratio = scrollWidth > 0 ? clientWidth / scrollWidth : 1;
          const maxScroll = scrollWidth - clientWidth;
          const progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;

          this.thumb.style.width = `${ratio * 100}%`;
          // Move the thumb within the leftover track space (100% - thumb width).
          this.thumb.style.transform = `translateX(${(progress * (1 - ratio) * 100) / ratio}%)`;
        }

        if (this.prevButton) this.prevButton.disabled = index <= 0;
        if (this.nextButton) this.nextButton.disabled = index >= this.slideCount - 1;
      }
    }
  );
}
